import { render, staticRenderFns } from "./WarehouseWorkDashboard.vue?vue&type=template&id=b28eb60c&scoped=true"
import script from "./WarehouseWorkDashboard.vue?vue&type=script&lang=js"
export * from "./WarehouseWorkDashboard.vue?vue&type=script&lang=js"
import style0 from "./WarehouseWorkDashboard.vue?vue&type=style&index=0&id=b28eb60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28eb60c",
  null
  
)

export default component.exports